import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { string, func, shape } from 'prop-types';
import { Container, CardContent, CardFigure, CardTitle, CardText, CardButton, FigureContainer } from './action-card.styles';

const ActionCard = _ref => {
  let {
    data,
    as,
    href,
    image,
    alt,
    onButtonClick,
    buttonProps
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["data", "as", "href", "image", "alt", "onButtonClick", "buttonProps"]);

  return /*#__PURE__*/React.createElement(Container, _extends({
    "data-testid": "card",
    hasFigure: Boolean(image)
  }, props), Boolean(image) && /*#__PURE__*/React.createElement(FigureContainer, {
    "data-testid": "card-figure"
  }, /*#__PURE__*/React.createElement(CardFigure, {
    src: image,
    alt: alt,
    width: 64,
    height: 64,
    lazy: true
  })), (Boolean(data.title) || Boolean(data.text)) && /*#__PURE__*/React.createElement(CardContent, {
    "data-testid": "card-content"
  }, Boolean(data.title) && /*#__PURE__*/React.createElement(CardTitle, {
    "data-testid": "card-title"
  }, data.title), Boolean(data.text) && /*#__PURE__*/React.createElement(CardText, {
    "data-testid": "card-text"
  }, data.text)), /*#__PURE__*/React.createElement(CardButton, _extends({
    "data-testid": "card-button",
    forwardedAs: href ? 'a' : as,
    href: href,
    onClick: onButtonClick,
    children: data.action
  }, buttonProps)));
};

process.env.NODE_ENV !== "production" ? ActionCard.propTypes = {
  as: string,
  data: shape({
    title: string,
    text: string,
    action: string
  }),
  buttonProps: shape({}),
  image: string,
  alt: string,
  href: string,
  action: string,
  onButtonClick: func
} : void 0;
ActionCard.defaultProps = {
  as: 'button',
  data: {
    title: '',
    text: '',
    action: ''
  },
  image: '',
  href: undefined,
  alt: '',
  onButtonClick: () => {}
};
export default ActionCard;